// Partner / member logos served from /public/logos. Filenames with spaces are
// URL-encoded so the browser fetches them correctly.
const logoFiles = [
  "ABS-Greentech-logo.png",
  "AGRI-BIZ FS.png",
  "ALUColour_WName.png",
  "AND-biologicals-logo.png",
  "CR-Advocates-LLP-Logo-Small-1.webp",
  "embassy-of-malaysia.png",
  "Geoponika.jpg",
  "investment5 (1).jpg",
  "Jubilee_Insurance_Logo.jpg",
  "kmpdu_icon.png",
  "lebustudios.png",
  "logo_airasiaX_2022.png",
  "Nyota Njema.png",
  "OMOH HOMES LOGO.jpg",
  "Robo.png",
  "Saya Events Logo.png",
  "sayasavtech.png",
  "VIGOR LOGO.png",
];

const logos = logoFiles.map((f) => ({
  src: `/logos/${encodeURIComponent(f)}`,
  alt: f.replace(/\.[^.]+$/, "").replace(/[-_]/g, " "),
}));

const LogoMarquee = () => {
  // Duplicate the list so the track can scroll seamlessly (-50% loop).
  const track = [...logos, ...logos];

  return (
    <section className="py-12 bg-background border-y border-border overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <span className="text-[11px] font-medium tracking-wider text-gold mb-2 block">
            TRUSTED ACROSS THE NETWORK
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-black leading-snug">
            Members &amp; partners building trade together
          </h2>
        </div>
      </div>

      {/* Edge fade masks for a polished look */}
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-28 z-10 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-28 z-10 bg-gradient-to-l from-background to-transparent" />

        <div className="group flex overflow-hidden">
          <div className="flex shrink-0 items-center animate-marquee group-hover:[animation-play-state:paused]">
            {track.map((logo, i) => (
              <div
                key={i}
                className="mx-6 sm:mx-9 flex h-16 w-32 sm:w-40 shrink-0 items-center justify-center"
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  loading="lazy"
                  className="max-h-12 sm:max-h-14 w-auto object-contain opacity-60 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
